export const checkAllDayLongEvent = (startTime?: string, endTime?: string, daysAmount?: number) => {
	return (daysAmount ?? 0) === 0 && startTime === "00:00" && endTime === "23:59";
};
